function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.8 47.65l-.008-.007c5.268-3.336 12.3-2.704 16.886 1.917l2.41 2.433V7.231c0-3.78 3.07-6.872 6.82-6.872 3.75 0 6.814 3.093 6.814 6.872v27.187c1.245-1.54 3.123-2.543 5.247-2.543 1.477 0 2.837.488 3.952 1.296l14.683 8.566-.01.017C60.623 42.943 62 45.128 62 47.657v11.3c0 12.288-9.88 22.245-22.072 22.245-5.904 0-11.254-2.35-15.212-6.157l-.003.031-23.357-23.54a2.512 2.512 0 01.443-3.886z",
  fill: "#FFF",
  fillRule: "nonzero"
});

var SvgScrollHand = function SvgScrollHand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 62 82",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScrollHand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scroll-hand.e8654cbe.svg";
export { ForwardRef as ReactComponent };